import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';

@Injectable()
export class LabAppGuard implements CanActivate {

  constructor(private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    let labAppAccess = localStorage.getItem('lab_app_access');
    if (labAppAccess !== undefined && labAppAccess !== null && labAppAccess !== '' && labAppAccess =='true') {
      return of(true);
    }
    else {
      this.router.navigate(['']);
      return of(false);
    }
  }
}